import { mapGetters } from "vuex";

// Restricts a view to admins (gendev / admin) — used for the live traffic + chat,
// which are admin-only until they're polished. Owners/tenants/comerciales are sent
// home. Keyed off currentUser (resolves after mount, so it works on a hard refresh).
// The backend resolvers enforce the same set.
const ADMIN_ROLES = ["gendev", "admin"];

export default {
  computed: { ...mapGetters(["currentUser"]) },
  watch: {
    currentUser: {
      immediate: true,
      handler(user) {
        if (!user || !Array.isArray(user.displayRoles)) return;
        if (!ADMIN_ROLES.some(r => user.displayRoles.includes(r))) {
          this.$router.replace("/");
        }
      }
    }
  }
};
